import styled from 'styled-components';
import { Text } from '../Text/Text.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const Paragraph = styled(Text)`
    margin-top: 0;
    margin-bottom: ${spacing("md")};
`;
Paragraph.displayName = "Paragraph";
Paragraph.defaultProps = {
  as: "p",
  size: "md",
  contrast: "base"
};

export { Paragraph };
//# sourceMappingURL=Paragraph.es.js.map
